import { PostMessageEvent, PostMessageData } from '~/constants/postMessages';
import { DifficultyTier } from '~/networking/schema';

export type PartialBy<T, K extends keyof T> = Omit<T, K> & Partial<Pick<T, K>>;

export const sendPostMessage = (
  message: PostMessageEvent,
  payload: PartialBy<Omit<PostMessageData, 'type'>, 'translationInfo'> | { difficultyTier: DifficultyTier },
) => {
  window.parent.postMessage({ type: message, ...payload }, '*');
};
